// src/services/businessService.js
import api from '../fapis/client';
import endpoints from '../fapis/endpoints';

// ========== ROLES ==========
export const getRoles = async () => {
  try {
    const response = await api.get(endpoints.retailone.roles);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// ========== INVITES ==========
export const sendInvite = async (email, roleId) => {
  try {
    const response = await api.post(endpoints.retailone.invite, { email, role_id: roleId });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const getInvites = async () => {
  try {
    const response = await api.get(endpoints.retailone.invites);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const resendInvite = async (userUuid) => {
  try {
    const response = await api.post(endpoints.retailone.resendInvite, { user_uuid: userUuid });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const deleteInvite = async (userUuid) => {
  try {
    const response = await api.delete(endpoints.retailone.deleteInvite(userUuid));
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// ========== SET PASSWORD (Accept Invite) ==========
export const verifyInviteToken = async (token) => {
  try {
    const response = await api.get(endpoints.retailone.verifyInvite(token));
    return { success: true, data: response.data };
  } catch (error) {
    return { 
      success: false, 
      message: error.message, 
      status: error.status,
      data: error.data
    };
  }
};

export const acceptInvite = async (token, fullName, phone, password) => {
  try {
    const response = await api.post(endpoints.retailone.acceptInvite, {
      token,
      full_name: fullName,
      phone,
      password
    });
    return { success: true, data: response.data };
  } catch (error) {
    return { 
      success: false, 
      message: error.message, 
      status: error.status,
      data: error.data
    };
  }
};

// ========== PROFILE ==========
export const getProfile = async () => {
  try {
    const response = await api.get(endpoints.retailone.profile);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message, status: error.status };
  }
};

export const updateProfile = async (fullName, phone) => {
  try {
    const response = await api.put(endpoints.retailone.profile, { full_name: fullName, phone });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message, status: error.status };
  }
};

export const changePassword = async (currentPassword, newPassword, confirmPassword) => {
  try {
    const response = await api.post(endpoints.retailone.changePassword, {
      current_password: currentPassword,
      new_password: newPassword,
      confirm_password: confirmPassword
    });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message, status: error.status };
  }
};

// ========== FORGOT PASSWORD ==========
export const forgotPassword = async (email) => {
  try {
    const response = await api.post(endpoints.retailone.forgotPassword, { email });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message, status: error.status };
  }
};

export const resetPassword = async (token, newPassword, confirmPassword) => {
  try {
    const response = await api.post(endpoints.retailone.resetPassword, {
      token,
      new_password: newPassword,
      confirm_password: confirmPassword || newPassword
    });
    return { success: true, data: response.data };
  } catch (error) {
    return { 
      success: false, 
      message: error.message, 
      status: error.status,
      data: error.data 
    };
  }
};

export const verifyResetToken = async (token) => {
  try {
    const response = await api.get(`${endpoints.retailone.verifyResetToken}?token=${token}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { 
      success: false, 
      message: error.message, 
      status: error.status,
      data: error.data 
    };
  }
};